

























































import { Component, Vue } from 'vue-property-decorator'
import PageHead from '@/components/PageHead.vue'
import { Notify } from '@/helpers/Notify'
import { Api } from '@/fetch/Api'
import type { UserFonts, AvailableFont } from '@/interfaces'

@Component({
  components: {
    PageHead,
  },
})
export default class SettingsFontsPage extends Vue {
  pageTitle = 'Font Customization'
  callInProgress = false
  userFontsBody: string = null
  userFontsContent: string = null
  userFontsFeatured: string = null
  userFonts: UserFonts = null
  availableFonts: AvailableFont[] = null

  mounted() {
    this.fetchDomainFonts()
  }

  public async fetchDomainFonts() {
    this.callInProgress = true
    try {
      const response = await Api.getDomainFonts()
      this.userFontsBody = response.userFontsBody
      this.userFontsContent = response.userFontsContent
      this.userFontsFeatured = response.userFontsFeatured
      this.userFonts = response.userFonts
      this.availableFonts = response.availableFonts
      this.callInProgress = false
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public async setDomainFonts() {
    this.callInProgress = true
    try {
      await Api.setDomainFonts(this.userFontsBody, this.userFontsContent, this.userFontsFeatured)
      this.callInProgress = false
      Notify.create({
        type: 'success',
        title: 'Saved',
        text: 'Website Font(s) Saved.',
      })
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }
}

